











































import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { PopisPneu } from '@/modules/ciselnik/ojeteVozy/popisPneu';

import { store } from '../store/edit';
import { editMutations } from '../store/types';

export default Vue.extend({
	name: 'TechStav1',
	components: {
		PneuPopisSelect: PopisPneu.components.Select,
	},
	props: {
		storeUri: { type: String, required: true },
	},
	data() {
		return {
			mutationsMappers: {
				pneuPopis: `${this.storeUri}/${editMutations.PNEU_POPIS_SELECT}`,
			},
		};
	},
	computed: {
		...genVuexComputeds(store),
	},
});
